<script setup lang="ts">
import Sidebar from '@/components/LayoutV2/Sidebar.vue';
import useGlobalStore from '@/store/globalStore';
import { onMounted, ref, watch } from 'vue';
import { debounce } from 'lodash-es';
const globalStore = useGlobalStore();
const sidebarRef = ref<HTMLElement | null>(null);
const layoutSize = ref({
  headerHeight: 0,
  sidebarWidth: 0,
});
const setLayoutSize = () => {
  layoutSize.value.sidebarWidth = sidebarRef.value?.clientWidth || 0;
};

onMounted(() => {
  setLayoutSize();
  const debSet = debounce(setLayoutSize, 100);
  window.addEventListener('resize', debSet);
  return () => {
    window.removeEventListener('resize', debSet);
  };
});

watch(
  () => globalStore.sidebarVisible,
  () => {
    setTimeout(() => {
      setLayoutSize();
    }, 20);
  }
);
</script>

<template>
  <div class="layout-v2">
    <div
      ref="sidebarRef"
      :class="{
        'layout-v2__sidebar': true,
        'layout-v2__sidebar--collapsed': globalStore.sidebarVisible === false,
      }"
    >
      <sidebar />
    </div>
    <div class="layout-v2__content">
      <slot v-bind="layoutSize"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.layout-v2 {
  display: flex;
  height: 100vh;
  overflow: hidden;
  .layout-v2__sidebar {
    width: 140px;
    flex: 0 0 140px;

    &--collapsed {
      width: 64px;
      flex: 0 0 64px;
    }
  }
  .layout-v2__content {
    flex: 1;
  }
}
</style>
